export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">联系我们</h2>
          <p className="text-sm text-foreground-500">有建议或合作意向？欢迎随时联系</p>
        </div>
        <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">商务合作</div>
              <div className="text-xs text-foreground-500">business@hongtao.tv</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100">
                <i className="ri-edit-2-line text-xl text-accent-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">内容投稿</div>
              <div className="text-xs text-foreground-500">contribute@hongtao.tv</div>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100">
                <i className="ri-customer-service-2-line text-xl text-secondary-600"></i>
              </div>
              <div className="text-sm font-bold text-foreground-900 mb-1">客服支持</div>
              <div className="text-xs text-foreground-500">support@hongtao.tv</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}